import { h, JSX } from 'preact';
import { createPortal } from 'preact/compat';
import classNames from 'classnames';
import CloseIcon from 'widget_main/globals/assets/close.svg';
import { MODAL_ROOT_ID } from 'widget_main/globals/constants';
import { useTranslations } from 'i18n/hooks';
import TitleBarButton from '../Button/TitleBarButton';
import styles from './modal.scss';
import messages from './messages';

interface ModalProps {
  show: boolean;
  closeButton?: boolean;
  onHide?: () => void;
  children?: JSX.Element | JSX.Element[] | string;
  className?: string;
  bodyClassName?: string;
}

const Modal = ({
  show,
  closeButton,
  onHide,
  className,
  bodyClassName,
  children,
}: ModalProps) => {
  const translations = useTranslations(messages);

  const renderCloseButton = () => {
    if (!closeButton) {
      return null;
    }

    return (
      <TitleBarButton
        ariaLabel={translations.closeModalAriaLabel}
        onClick={onHide}
        className={styles.closeButton}
      >
        <CloseIcon width={20} height={20} />
      </TitleBarButton>
    );
  };

  const modalRoot = document.getElementById(MODAL_ROOT_ID);

  if (!show || !modalRoot) {
    return null;
  }
  return createPortal(
    <div className={styles.container}>
      <div className={classNames(styles.modal, className)}>
        {renderCloseButton()}
        <div className={classNames(styles.body, bodyClassName)}>{children}</div>
      </div>
    </div>,
    modalRoot,
  );
};

export default Modal;
